import React from 'react';
import {useTranslation} from 'react-i18next';
import {DEAL_STATUSES} from '@chekin/core';
import {useTheme} from 'styled-components';

import {Container, StyledIcon, Text} from './styled';

type Props = {
  status: DEAL_STATUSES;
};

const visibleStatuses = [
  DEAL_STATUSES.approved,
  DEAL_STATUSES.pre_requested,
];

const OfferCardMark = ({status}: Props) => {
  const {t} = useTranslation();
  const theme = useTheme();

  if (!visibleStatuses.includes(status)) {
    return null;
  }

  return (
    <Container>
      <StyledIcon
        name="shoppingCart"
        size={16}
        color={theme.colors.buttons.mainButtonTextBackground}
      />
      <Text>{t('offer_list_view.added')}</Text>
    </Container>
  );
};

export {OfferCardMark};
